import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Dialog from '@mui/material/Dialog';
import Tooltip from '@mui/material/Tooltip';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import NotesIcon from '@mui/icons-material/Notes';
import useIsMobile from '../hooks/useIsMobile';
import { useThemeStatics } from '../hooks/useThemeConfig';

export default function TerminosyCondiciones() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const mobile = useIsMobile();
  const staticConfig = useThemeStatics();
	const { terminosYCondiciones: pdfUrl } = staticConfig;
  return (
    <Tooltip title="Ver términos y condiciones" placement="bottom">
      <Box >
        <Fab color="primary" aria-label="ver" onClick={handleClickOpen}>
          <NotesIcon />
        </Fab>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle id="alert-dialog-title">{"Términos y condiciones"}</DialogTitle>
          <DialogContent>
            <iframe src={pdfUrl} title="Términos y condiciones" height={mobile ? '500px' : ' 500px'} width={mobile ? '350px' : ' 1150px'}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="contained" color="secondary">
              Cerrar
            </Button>
            <Button onClick={handleClose} variant="contained" color="primary" autoFocus>
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer" download>
                 Descargar
              </a>
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Tooltip>
  );
}